import { render, staticRenderFns } from "./addQuestionnaire.vue?vue&type=template&id=31dc5fd0"
import script from "./addQuestionnaire.vue?vue&type=script&lang=js"
export * from "./addQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31dc5fd0')) {
      api.createRecord('31dc5fd0', component.options)
    } else {
      api.reload('31dc5fd0', component.options)
    }
    module.hot.accept("./addQuestionnaire.vue?vue&type=template&id=31dc5fd0", function () {
      api.rerender('31dc5fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/components/addQuestionnaire.vue"
export default component.exports